var React = require('react');

function RoundRight (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.75","y":"31.25","width":"30.5","height":"30.5","rx":"15.25","transform":"rotate(-90 0.75 31.25)","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.6261 9.95954C14.0167 9.56902 14.6498 9.56902 15.0404 9.95954L20.3737 15.2929C20.7642 15.6834 20.7642 16.3166 20.3737 16.7071L15.0404 22.0404C14.6498 22.4309 14.0167 22.4309 13.6261 22.0404C13.2356 21.6499 13.2356 21.0167 13.6261 20.6262L18.2524 16L13.6261 11.3738C13.2356 10.9832 13.2356 10.3501 13.6261 9.95954Z","fill":"#8C8C8C","key":1}),React.createElement("rect",{"x":"0.75","y":"31.25","width":"30.5","height":"30.5","rx":"15.25","transform":"rotate(-90 0.75 31.25)","stroke":"#EDEDED","strokeWidth":"1.5","key":2})]);
}

RoundRight.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = RoundRight;

RoundRight.default = RoundRight;
